export const formatData = (data: any[], page: number, perPage: number) => {
  return data?.map((el, i) => ({ ...el, number: (page - 1) * perPage + i + 1 }));
};
